import {
  parseStudentBillingPaymentMethodStateDto,
  parseStudentBillingPaymentSetupSessionDto,
  type StudentBillingPaymentMethodStateDto,
  type StudentBillingPaymentSetupSessionDto
} from "@madamuh/domain";
import { apiGet, apiPostWithHeaders } from "./client";

export async function fetchOwnStudentBillingPaymentMethod(tenantSlug: string): Promise<StudentBillingPaymentMethodStateDto> {
  return parseStudentBillingPaymentMethodStateDto(await apiGet(`/api/v1/app/tenants/${tenantSlug}/billing/payment-method`));
}

export async function beginOwnStudentBillingPaymentSetup(tenantSlug: string): Promise<StudentBillingPaymentSetupSessionDto> {
  return parseStudentBillingPaymentSetupSessionDto(await apiPostWithHeaders(
    `/api/v1/app/tenants/${tenantSlug}/billing/payment-setup-sessions`,
    {},
    { "Idempotency-Key": crypto.randomUUID() }
  ));
}
